<!-- 
  
  超宽屏定制页，主页

-->
<template>
  <div id="ultra-width-screen-wrapper">
    <el-row :gutter="24" id="ultra-width-screen-content">
      <!-- 最左 -->
      <el-col :span="5">
        <!-- 左上角板块：产业概况等 -->
        <summary-zone></summary-zone>
        <!-- 左下板块：辐射带动、种苗等 -->
        <infuluence-zone></infuluence-zone>
      </el-col>
      <!-- 中间 -->
      <el-col :span="14">
        <el-row>
          <el-col :span="24">
            <!-- 页面主标题 -->
            <title-zone></title-zone>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- 中间左侧 -->
          <el-col :span="6">
            <administration-zone></administration-zone>
          </el-col>
          <el-col :span="12">
            <!-- 正中间板块 -->
            <map-zone></map-zone>
          </el-col>
          <!-- 中间右侧 -->
          <el-col :span="6">
            <quality-zone></quality-zone>
          </el-col>
        </el-row>
      </el-col>
      <!-- 最右 -->
      <el-col :span="5">
        <market-zone></market-zone>
      </el-col>
    </el-row>

    <weather-zone></weather-zone>
  </div>
</template>
<script>
import TitleZone from './title-zone'
import SummaryZone from './summary-zone'
import InfuluenceZone from './influence-zone'
import AdministrationZone from './administration-zone'
import QualityZone from './quality-zone'
import MarketZone from './market-zone'
import WeatherZone from './weather-zone'

import MapZone from './map-zone'
export default {
  components: {
    TitleZone,
    MapZone,
    SummaryZone,
    InfuluenceZone,
    AdministrationZone,
    QualityZone,
    MarketZone,
    WeatherZone,
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
#ultra-width-screen-wrapper {
  width: 100%;
  height: 100%;
  background-color: #091220;
}
#ultra-width-screen-content {
  width: 3840px;
  height: 960px;
  padding: 10px;
  border: solid 1px #2f1f1f;
}
</style>


// WEBPACK FOOTER //
// src/components/screen38496/index.vue